const React = require('react');

class PriceRange extends React.Component {
  shouldRender() {
    return this.props.retailBottom && this.props.retailTop;
  }

  get retailBottomDisplayPrice() {
    return this.props.retailBottom.display;
  }

  get retailTopDisplayPrice() {
    return this.props.retailTop.display;
  }

  render() {
    if (!this.shouldRender()) {
      return null;
    }

    return (
      <section className="mb-1">
        <h2 className="heading-3">
          {I18n.t('js.transactionHistory.priceRangeHeader')}
        </h2>
        <ul className="inline-list prices">
          <li className="strong">
            <span className="used">
              {this.retailBottomDisplayPrice}
            </span>
            {' '}
            &mdash;
            {' '}
            <span className="used">
              {this.retailTopDisplayPrice}
            </span>
          </li>
        </ul>
      </section>
    );
  }
}

PriceRange.propTypes = {
  retailBottom: React.PropTypes.object,
  retailTop: React.PropTypes.object,
};

module.exports = PriceRange;



// WEBPACK FOOTER //
// ./javascripts/components/price_guide/transaction_history/price_range.jsx